import { gql } from '@apollo/client';

export const CREATE_AD_SET_NOTE = gql`
  mutation CreateAdSetNote($request: CreateAdSetNoteRequest!) {
    CreateAdSetNote(request: $request) {
      id
    }
  }
`;

export const DELETE_AD_SET_NOTE = gql`
  mutation DeleteAdSetNote($id: String!) {
    DeleteAdSetNote(id: $id)
  }
`;
